const logEvent = (data) => {
  if (!window.dataLayer) return;
  if (typeof data !== 'object') {
    console.error('Data should be an object');
    return;
  }
  window.dataLayer.push({
    ...data,
  });

  if (import.meta.env.VITE_ENV === 'development') {
    console.log('GTM Event:', data);
  }
};

export const logPageView = (to) => {
  if (!to) return;
  logEvent({
    event: 'page_view',
    page_path: to.fullPath,
    page_title: document.title,
    page_location: window.location.href,
  });
};

export const logCustomEvent = (eventTitle, data) => {
  logEvent({
    event: eventTitle,
    ...data,
  });
};

export const logOrderDetails = (orderData) => {
  if (!orderData) return;
  logCustomEvent('order_started', {
    order_type: orderData.orderType || 'unknown',
    coin_type: orderData?.coinType,
    fiat_type: orderData?.fiatType,
    fiat_amount: orderData?.fiatAmount,
    coin_amount: orderData?.coinAmount,
    payment_method: orderData?.payment,
  });
};

export const logCustomerId = (customerId) => { logCustomEvent('user_context', { customer_id: customerId }); };

export const logOrderKey = (orderKey) => { logCustomEvent('user_context', { order_key: orderKey }); };

export const logError = (error) => {
  if (!error) return;
  logCustomEvent('app_error', {
    error_type: error?.type || 'Unknown error type',
    error_code: error?.code || 'Unknown error code',
    error_message: error?.message || 'Unknown error',
    error_trace_id: error?.traceId || null,
  });
};
